var map = {
	"./ground-ground-day.png": "9a37",
	"./ground-ground-evening.png": "9fc2",
	"./ground-ground-morning.png": "6371",
	"./ground-ground-night.png": "aa6d",
	"./ground-ground.png": "609e",
	"./ground-mountain-day.png": "81b5",
	"./ground-mountain-evening.png": "db59",
	"./ground-mountain-morning.png": "af88",
	"./ground-mountain-night.png": "07c8",
	"./ground-mountain.png": "6d80",
	"./ground-river-day.png": "ce25",
	"./ground-river-evening.png": "401f",
	"./ground-river-morning.png": "5f5a",
	"./ground-river-night.png": "21e8",
	"./ground-river.png": "dfd7",
	"./ground-sea-cool.png": "f305",
	"./ground-sea-day.png": "ee39",
	"./ground-sea-evening.png": "e940",
	"./ground-sea-morning.png": "75b3",
	"./ground-sea-night.png": "764a",
	"./ground-sea.png": "2180"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5896";